import React from 'react'
import Hero from 'parts/Retail/Hero'
import Stuff from 'parts/Retail/Stuff'
import Why from 'parts/Retail/Why'
import Maps from 'parts/Retail/Maps'
import SupplyWarranty from 'parts/Retail/SupplyWarranty'
import WhoCanJoin from 'parts/Retail/WhoCanJoin'
import Testimoni from 'parts/Retail/Testimoni'
import Join from 'parts/Retail/Join'

const Retail = () => {
  return (
    <>
      <Hero />
      <Why />
      <SupplyWarranty />
      <Stuff />
      <WhoCanJoin />
      <Maps />
      <Testimoni />
      <Join />
    </>
  )
}

export default Retail
